module.exports = __webpack_public_path__ + "img/coin.ca005d6e.png";